module.exports = __webpack_public_path__ + "static/media/clean.3fe08f76.png";